'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _coreDecorators = require('core-decorators');

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabsStateful = (0, _coreDecorators.autobind)(_class = function (_PureComponent) {
  (0, _inherits3.default)(TabsStateful, _PureComponent);

  function TabsStateful(props) {
    (0, _classCallCheck3.default)(this, TabsStateful);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TabsStateful.__proto__ || (0, _getPrototypeOf2.default)(TabsStateful)).call(this, props));

    _this.state = {
      activeTab: props.initialTab ? props.initialTab : _lodash2.default.get(props, 'items.length') ? _lodash2.default.get(props, 'items[0].name') : null
    };
    return _this;
  }

  (0, _createClass3.default)(TabsStateful, [{
    key: 'onChange',
    value: function onChange(_ref) {
      var name = _ref.name;

      this.setState({ activeTab: name });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          initialTab = _props.initialTab,
          rest = (0, _objectWithoutProperties3.default)(_props, ['initialTab']);

      return _react2.default.createElement(_tabs2.default, (0, _extends3.default)({}, rest, {
        activeTab: this.state.activeTab,
        onChange: this.onChange
      }));
    }
  }]);
  return TabsStateful;
}(_react.PureComponent)) || _class;

process.env.NODE_ENV !== "production" ? TabsStateful.propTypes = {
  initialTab: _propTypes2.default.string,
  items: _propTypes2.default.array
} : void 0;
exports.default = TabsStateful;